import { blacklistedUrls } from './blacklistedUrls';

export interface WebsiteInfo {
  id: string;
  title: string;
  url: string;
  favicon: string;
}

export const normalizeUrl = (url: string): string => {
  return url
    .toLowerCase()
    .replace(/^(https?:\/\/)?(www\.)?/, '')
    .trim();
};

export const filterBlacklistedSources = (
  sources: WebsiteInfo[]
): WebsiteInfo[] => {
  const normalizedBlacklist = blacklistedUrls.map(url => normalizeUrl(url));

  return sources.filter(source => {
    const normalizedSource = normalizeUrl(source.url);
    return normalizedBlacklist.some(
      blacklisted =>
        normalizedSource === blacklisted ||
        normalizedSource.startsWith(blacklisted + '/') ||
        normalizedSource.startsWith(blacklisted + '?')
    );
  });
};

export const isUrlBlacklisted = (url: string): boolean => {
  const normalizedBlacklist = blacklistedUrls.map(u => normalizeUrl(u));
  const normalized = normalizeUrl(url);

  return normalizedBlacklist.some(
    blacklisted =>
      normalized === blacklisted ||
      normalized.startsWith(blacklisted + '/') ||
      normalized.startsWith(blacklisted + '?')
  );
};
